import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = false;

const editPassAvatarMobileSlice = createSlice({
	name: 'editPassAvatarMobile',
	initialState,
	reducers: {
		setDisplayModalEditPassAvatarMobile: (state, action: PayloadAction<boolean>) => {
			return action.payload;
		}
	}
});

export const { setDisplayModalEditPassAvatarMobile } = editPassAvatarMobileSlice.actions;

export default editPassAvatarMobileSlice.reducer;
